import { Col, Row, } from 'antd';
import cs from 'classnames';
import { useState, useEffect } from 'react';
import { SmallFleet } from '../../../Icons/SmallFleet';

import styles from './styles.module.scss';
import { LOGOS } from '../../../../const/logos';
import { IDefaultLogo } from '../../../../interfaces/logo.interface';

const defaultLogos: IDefaultLogo[] = LOGOS.driver;

interface ILogo extends IDefaultLogo {
  setDefaultLogo?: (params: string) => void
  existDefaultLogo?: null | string;
}

const DefaultLogo = ({
  setDefaultLogo,
  existDefaultLogo
}: ILogo) => {
  const [checked, setChecked] = useState('');
  const handleOnChange = (value: string) => {
    setChecked(value);
    setDefaultLogo && setDefaultLogo(value);
    return value;
  };

  useEffect(() => {
    if (existDefaultLogo) {
      setChecked(existDefaultLogo);
      setDefaultLogo && setDefaultLogo(existDefaultLogo);
    }
  }, [existDefaultLogo]);

  return (
    <Row justify="space-evenly">
      {
        defaultLogos.map((logo: ILogo) =>
          <Col
            key={logo.type}
            className={
              cs(
                styles.logoContainer
              )
            }
            style={checked === logo.type ? { background: logo.background } : {}}
            onClick={() => handleOnChange(logo.type)}
          >
            <div className="flex-column center-column-center">
              <SmallFleet size={72} color={logo.color} fleetBackground={checked === logo.type ? logo.background : ""} />
            </div>
          </Col>
        )
      }
    </Row>
  )
}

export default DefaultLogo